class FacetCount extends window.BAO.CustomElement({
  SuperClass: HTMLSpanElement,
}) {
  constructor () {
    super()

    this.state = {
      root: window.theme.category
        ? window.theme.category.stateLayer.state
        : window.theme.searchResults.stateLayer.state,
    }

    this.eventBus = window.theme.category
      ? window.theme.category.eventBus
      : window.theme.searchResults.eventBus
  }

  connectedCallback () {
    this.subscribeToEvents()
  }

  subscribeToEvents () {
    this.eventBus.subscribe('state:activeFacets:updated', () => {
      if (this.count > 0) {
        this.innerHTML = ` (${this.count})`
      } else {
        this.innerHTML = ''
      }
    })

    this.eventBus.subscribe('api:facets:fetched', () => {
      if (this.count > 0) {
        this.innerHTML = ` (${this.count})`
      } else {
        this.innerHTML = ''
      }
    })
  }

  get count () {
    const activeFacets = this.state.root.activeFacets

    let totalValues = 0

    for (const facet of activeFacets) {
      if (facet.key === 'klevu_price') {
        totalValues += 1
      } else {
        if (facet.values && Array.isArray(facet.values)) {
          totalValues += facet.values.length
        }
      }
    }

    return totalValues
  }
}

window.customElements.define('facet-count', FacetCount, {
  extends: 'span',
})
